const getEasternDateTime = () => {
  const date = new Date()
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  })

  const parts = formatter.formatToParts(date)
  const getValue = (type: string) => parts.find((part) => part.type === type)?.value || ''

  const year = getValue('year')
  const month = getValue('month')
  const day = getValue('day')
  const hour = getValue('hour')
  const minute = getValue('minute')
  const second = getValue('second')

  const isDST = isEasternDST(date)
  const offset = isDST ? '-04:00' : '-05:00'

  return `${year}-${month}-${day}T${hour}:${minute}:${second}${offset}`
}

const isEasternDST = (date: Date): boolean => {
  const january = new Date(date.getFullYear(), 0, 1)
  const july = new Date(date.getFullYear(), 6, 1)
  const stdOffset = Math.max(january.getTimezoneOffset(), july.getTimezoneOffset())
  return date.getTimezoneOffset() < stdOffset
}

export { getEasternDateTime, isEasternDST }
